import React from "react";
import "../../Styles/certified/prochant.css";

export default function Prochant() {
  return (
    <>
      <div className="prochant-details-section">
        <div className="prochant-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="prochant-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="prochant-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="prochant-badge"
            />
            <div className="prochant-company-names">
              <a href="https://www.prochant.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/prochant/prochantlogo.png" alt="Prochant Logo" className="prochant-company-logo" />
              </a>
              <h1 className="prochant-full-name">
                Prochant India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="prochant-details-right">
            <img
              src="/assets/prochant/pro2.jpg"
              alt="Prochant Office"
              className="prochant-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="prochant-description">
          <h2>
            Why Prochant India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           • Prochant is a leading technology- and platform-led company in the healthcare service sector, specialized in Revenue Cycle Management (RCM) .<br/> <br/>
           • With global capability centers across the US, South America, and India, we deliver superior human cognition, deep RCM expertise, AI-driven workflows, BPaaS-based analytics, and healthcare hyper-automation. <br/> <br/>
           • Combining industry-leading knowledge with advanced technology, Prochant supports major home-based care enterprises, top health systems, and the world’s largest HME providers—helping them streamline operations, optimize financial performance, and elevate care outcomes. 
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="prochant-info-cards">
          <div className="prochant-info-card">
            <div className="prochant-info-title">COMPANY SIZE</div>
            <div className="prochant-info-value">3800 Employees</div>
          </div>
          <div className="prochant-info-card">
            <div className="prochant-info-title">INDUSTRY</div>
            <div className="prochant-info-value">Healthcare Technology</div>
          </div>
          <div className="prochant-info-card">
            <div className="prochant-info-title">CONNECT</div>
            <div className="prochant-info-icons">
              <span className="prochant-icon-round">
                <a href="https://www.prochant.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="prochant-icon-round">
                <a href="https://www.linkedin.com/company/prochant" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="prochant-icon-round">
                <a href="https://www.facebook.com/prochant" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="contus-certified-icon-round">
                <a href="https://www.youtube.com/channel/UCjeN0Gr0_Kh2PiQEUtvYf4Q" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/youtube.png" alt="YouTube" />
                </a>
              </span>
              <span className="prochant-icon-round">
                <a href="https://x.com/prochant" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="prochant-info-card">
            <div className="prochant-info-title">LOCATION (HQ)</div>
            <div className="prochant-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="prochant-recognition-section">
          <h2 className="prochant-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="prochant-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="prochant-recognition-image"
            />
          </div>
          <div className="prochant-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Prochant Section */}
        <div className="prochant-life-section">
          <h2 className="prochant-life-title">
            Life at Prochant India Private Limited
          </h2>
          <div className="prochant-life-gallery">
            <div className="prochant-life-col">
              <img src="/assets/prochant/pro4.jpg" alt="Office 1" className="prochant-life-img" />
              <img src="/assets/prochant/pro1.jpg" alt="Meeting 1" className="prochant-life-img" />
            </div>
            <div className="prochant-life-col prochant-life-center">
              <img src="/assets/prochant/pro5.jpg" alt="Main Office" className="prochant-life-img prochant-life-img-large" />
            </div>
            <div className="prochant-life-col">
              <img src="/assets/prochant/pro6.jpg" alt="Office 2" className="prochant-life-img" />
              <img src="/assets/prochant/pro3.jpg" alt="Meeting 2" className="prochant-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}